import { Avatar, Box, CircularProgress, Typography } from '@mui/material';
import logo from '../../assets/images/logo.png';

export const RouteHydrateFallback = () => {
  return (
    <Box className="min-h-screen flex items-center justify-center p-8 bg-gradient-to-br from-slate-50 to-blue-50">
      <Box className="max-w-sm w-full p-8 bg-white rounded-3xl shadow-2xl border border-slate-200 text-center">
        <Box className="flex items-center justify-center mb-6">
          <Avatar className="!h-[6rem] !w-[6rem]" alt="Logo" src={logo} />
        </Box>
        <CircularProgress size={32} thickness={4} />
        <Typography className="!mt-5 !text-sm !text-slate-600">Cargando aplicación...</Typography>
      </Box>
    </Box>
  );
};
